// Drei Radioknoepfe in einem fieldset, kein Kippschalter: ein Kippschalter kennt zwei Zustaende,
// dieses Merkmal hat drei. Radios sind ausserdem von Haus aus eine Gruppe mit gemeinsamer
// Beschriftung — genau das, was ein Screenreader hier ansagen soll.
import { useId, type ReactElement } from 'react'
import { useFarbschema, type Farbschema } from '../theme'

const WAHLEN: ReadonlyArray<{ wert: Farbschema; beschriftung: string }> = [
  { wert: 'system', beschriftung: 'System' },
  { wert: 'hell', beschriftung: 'Hell' },
  { wert: 'dunkel', beschriftung: 'Dunkel' },
]

export function FarbschemaSchalter(): ReactElement {
  const { wahl, setzen } = useFarbschema()
  const gruppe = useId()

  return (
    <fieldset
      // Ein blankes <fieldset> traegt die Rolle `group`. Fuer eine Gruppe von Radios erwartet eine
      // Vorlesesoftware `radiogroup` — ARIA in HTML erlaubt die Rolle auf fieldset ausdruecklich,
      // und die <legend> bleibt die Beschriftung der Gruppe.
      role="radiogroup"
      className="farbschema"
    >
      <legend className="farbschema-titel">Farbschema</legend>
      {/* Ein Segmentschalter: die Radios bleiben echte, fokussierbare Eingaben (seiten.css blendet
          sie nur optisch aus), die Beschriftungen sind die Segmente. */}
      <span className="farbschema-segmente">
        {WAHLEN.map(({ wert, beschriftung }) => {
          const id = `${gruppe}-${wert}`
          return (
            <span key={wert} className="farbschema-wahl">
              <input
                id={id}
                type="radio"
                name={gruppe}
                value={wert}
                checked={wahl === wert}
                onChange={() => setzen(wert)}
              />
              <label htmlFor={id}>{beschriftung}</label>
            </span>
          )
        })}
      </span>
    </fieldset>
  )
}
